module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Flag-49bef26cd6bb81b8b8e60e06efe0e632.svg";